import { Repository } from "src/firebase/firestore/repository";

type UserFollowing = {
  userId: string; // coach id
  followingId: string; // learner id
  createdAt?: any;
};

class UserFollowingRepository extends Repository<UserFollowing> {
  constructor() {
    // NOTE: Adjust collection name if different in your project
    super("user_followings");
  }

  async isCoachFollowingLearner(coachId: string, learnerId: string): Promise<boolean> {
    const res = (await this.find({ where: { userId: coachId, followingId: learnerId }, limit: 1 })) as (UserFollowing & {
      id: string;
    })[];
    return res.length > 0;
  }
}

export const userFollowingRepository = new UserFollowingRepository();


